/* eslint-disable */
import type * as Types from '../../../../graphql/gql-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateAutopilotEnabledMutationVariables = Types.Exact<{
  propertyId: Types.Scalars['String'];
  autopilotEnabled: Types.Scalars['Boolean'];
}>;


export type UpdateAutopilotEnabledMutation = { __typename?: 'Mutation', updateAutopilotEnabled?: { __typename?: 'Property', property_id?: string | undefined, autopilot_enabled?: boolean | undefined } | undefined };


export const UpdateAutopilotEnabledDocument = gql`
    mutation UpdateAutopilotEnabled($propertyId: String!, $autopilotEnabled: Boolean!) {
  updateAutopilotEnabled(
    propertyId: $propertyId
    autopilotEnabled: $autopilotEnabled
  ) {
    property_id
    autopilot_enabled
  }
}
    `;
export type UpdateAutopilotEnabledMutationFn = Apollo.MutationFunction<UpdateAutopilotEnabledMutation, UpdateAutopilotEnabledMutationVariables>;

/**
 * __useUpdateAutopilotEnabledMutation__
 *
 * To run a mutation, you first call `useUpdateAutopilotEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAutopilotEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAutopilotEnabledMutation, { data, loading, error }] = useUpdateAutopilotEnabledMutation({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *      autopilotEnabled: // value for 'autopilotEnabled'
 *   },
 * });
 */
export function useUpdateAutopilotEnabledMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAutopilotEnabledMutation, UpdateAutopilotEnabledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAutopilotEnabledMutation, UpdateAutopilotEnabledMutationVariables>(UpdateAutopilotEnabledDocument, options);
      }
export type UpdateAutopilotEnabledMutationHookResult = ReturnType<typeof useUpdateAutopilotEnabledMutation>;
export type UpdateAutopilotEnabledMutationResult = Apollo.MutationResult<UpdateAutopilotEnabledMutation>;
export type UpdateAutopilotEnabledMutationOptions = Apollo.BaseMutationOptions<UpdateAutopilotEnabledMutation, UpdateAutopilotEnabledMutationVariables>;
export const namedOperations = {
  Mutation: {
    UpdateAutopilotEnabled: 'UpdateAutopilotEnabled'
  }
}